import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import Scanner from 'react-webcam-qr-scanner'

// graphql
import gql from 'graphql-tag'
import { useMutation, useLazyQuery } from '@apollo/react-hooks'

// semantic-ui
import {
  Button,
  Form,
  Header,
  Icon,
  Container,
  Message,
  List
} from 'semantic-ui-react'

// styles
import './CreateDevices.css'

// graphql mutation
const CREATE_DEVICES = gql`
mutation IdMutation($input: CreateDevicesInput!) {
  create_devices(input: $input) {
    id
    serial
  }
}
`
// graphql query
const DEVICES = gql`
query GetDevices {
  me {
    id
    devices {
      id
      serial
      created_at
    }
  }
}
`

// Serial input component
const InputSerial = props => {

  // states
  const [value, setValue] = useState(props.val)
  // duplicate while typing in list
  const isDuplicate = duplArr => {
    return (duplArr && duplArr.length > 0 && duplArr.filter(d => d === value).length) ? true : false
  }
  const [errorDuplicate, setErrorDuplicate] = useState(isDuplicate(props.duplicates))
  // duplicate while typing in DB
  const isDuplicateDB = duplArr => {
    return duplArr && duplArr.length > 0 && duplArr.filter(d => d.serial === value)
  }
  const [errorDuplicateDB, setErrorDuplicateDB] = useState(isDuplicateDB(props.duplicatesInDB))
  const [errorEmptyInput, setErrorEmptyInput] = useState(false)
  // qr code watching
  const [watching, setWatching] = useState(false)
  const [facingMode, setFacingMode] = useState('environment')
  const [qrError, setQRError] = useState(false)

  const handleChange = (event, { name, value }) => {
    // if value is empty
    if (value) {
      // setEmptyInput(false)
      setErrorEmptyInput(false)
      setValue(value)
    } else {
      // setEmptyInput(true)
      setErrorEmptyInput(true)
      setValue('')
    }
    // send data to parent component
    props.handleChange({ name, value })
  }

  const handleRemove = e => {
    e.preventDefault()
    props.removeThis(props.i)
  }

  const handleAddMore = e => {
    e.preventDefault()
    props.addMore()
  }

  // scan actions
  const openScanArea = e => {
    e.preventDefault()
    setWatching(true)
  }
  const handleScanQRCode = e => {
    if (e) {
      let result
      // validating scan
      try {
        result = JSON.parse(e.data).serial
      } catch (err) {
        setQRError(true)
        setTimeout(() => {
          setQRError(false)
        }, 3000)
        console.log('not a valid qr format', e)
      }
      // setting the value
      if (result) {
        setErrorEmptyInput(false)
        setValue(result)
        props.handleChange({
          name: props.i,
          value: result
        })
      }
      // hide scaner
      setWatching(false)
    }
  }
  const handleSwitchCamera = e => {
    e.preventDefault()
    let view = facingMode === 'environment' ? 'user' : 'environment'
    setFacingMode(view)
  }
  const handleScanError = e => {
    console.log(e)
  }
  // scan styles
  const previewStyle = {
    width: '100%',
    height: '100vh',
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 999
  }

  useEffect(() => {
    // checkInput changed
    if (props && props.checkInput) {
      if (!value || value === '') {
        setErrorEmptyInput(true)
      }
    }
    // duplicate in list found
    if (props && props.duplicates) {
      setErrorDuplicate(isDuplicate(props.duplicates))
    }
    // duplicate in DB found
    if (props && props.duplicatesInDB) {
      setErrorDuplicateDB(isDuplicateDB(props.duplicatesInDB))
    }
  }, [props])

  return (
    <>
      <Form.Input
        name={props.i}
        type='text'
        placeholder='Enter Serial'
        required
        onChange={handleChange}
        error={errorEmptyInput}
        value={value}
      >
        <input />
        {!!props.i && (
          <Button
            onClick={handleRemove}
          >
            <Icon name='remove' />
          </Button>
        )}
        {!!props.isLast && (
          <Button
            onClick={handleAddMore}
          >
            <Icon name='add' />add
          </Button>
        )}
        <Button
          onClick={openScanArea}
        >
          <Icon name='photo' />scan
        </Button>
        {watching && (
          <>
            <Scanner
              className='scanner'
              onDecode={handleScanQRCode}
              constraints={{
                audio: false,
                video: {
                  facingMode
                }
              }}
            />
            <Button
              className='switch-camera-button'
              onClick={handleSwitchCamera}
              negative
            >
              Switch camera
            </Button>
          </>
        )}
      </Form.Input>
      {qrError && (
        <Message
          negative
          size='mini'
        >
          <Message.Header>QR Code Error!</Message.Header>
          <p>Not a valid QR Code format!</p>
        </Message>
      )}
      {errorEmptyInput && (
        <Message
          negative
          size='mini'
        >
          <Message.Header>Empty Input</Message.Header>
          <p>Serial can not be empty!</p>
        </Message>
      )}
      {errorDuplicate && (
        <Message
          negative
          size='mini'
        >
          <Message.Header>Duplicated device!</Message.Header>
          <p>Device is already on the list!</p>
        </Message>
      )}
      {errorDuplicateDB && errorDuplicateDB.length > 0 && (
        <Message
          negative
          size='mini'
        >
          <Message.Header style={{marginBottom: '0.5rem'}}>Device exists in DataBase!</Message.Header>
          <Message.Content floated='right'>
            <p>Serial: {errorDuplicateDB && errorDuplicateDB.length > 0 && errorDuplicateDB[0].serial}</p>
            <p>Added on: {errorDuplicateDB && errorDuplicateDB.length > 0 && moment(errorDuplicateDB[0].created_at).format('DD/MMM/YYYY')}</p>
          </Message.Content>
        </Message>
      )}
    </>
  )
}

// page component
function CreateDevices (props)  {
  // states
  let [devices, setDevices] = useState([])
  let [po, setPo] = useState('')
  let [purchased, setPurchased] = useState('')
  let [serial, setSerial] = useState([''])
  let [checkInput, setCheckInput] = useState(0)
  let [errFields, setErrFields] = useState(false)
  let [duplicateInList, setDuplicateInList] = useState(false)
  let [duplicatesInDB, setDuplicatesInDB] = useState([])
  // oncompleted messages
  let [oncSuccess, setOncSuccess] = useState(false)
  let [oncWarn, setOncWarn] = useState(false)
  let [oncWarnNmb, setOncWarnNmb] = useState(0)
  let [oncErr, setOncErr] = useState(false)
  let [serialsMemo, setSerialsMemo] = useState([])
  // duplicates warning
  let [duplWarn, setDuplWarn] = useState(false)
  let [duplicates, setDuplicates] = useState([])

  // query devices
  const [initDevices] = useLazyQuery(DEVICES, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      // set new set of devices
      setDevices(data.me.devices)
    }
  })
  const [getDevices, { refetch }] = useLazyQuery(DEVICES, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      setDuplWarn(true)
      // check for duplicates (previously loaded devices)
      let dupls = devices.filter(device => {
        let found = false
        serialsMemo.forEach(sm => {
          if (sm === device.serial) found = device
        })
        return found
      })
      setDuplicates(dupls)
      // set new set of devices
      setDevices(data.me.devices)
    }
  })

  const handleSubmit = (event, b, c) => {
    event.preventDefault()
    // reset duplicates warning
    setDuplWarn(false)
    setDuplicates([])
    setCheckInput(checkInput + 1)
    // check empty serial inputs
    let empty = serial.filter(s => !s || s === '').length
    if (empty) {
      // rerender inputs in order to display errors
      let oldSerial = _.cloneDeep(serial)
      setSerial([])
      setTimeout(() => {
        setSerial(oldSerial)
      }, 10)
    }
    if (!po || !purchased) {
      setErrFields(true)
    } else {
      setErrFields(false)
    }
    if (!empty && po && purchased) {
      // submit form
      let standardDate = moment(purchased).toISOString()
      createDevices({
        variables: {
          input: {
            po_number: po,
            purchased_at: standardDate,
            serial
          }
        }
      })
    }
  }

  const checkForArrDuplicates = serials => {
    let nonEmptyArr = serials.filter(s => s !== '')
    // find duplicates
    let duplicates = _.filter(nonEmptyArr, (value, index, iteratee) => _.includes(iteratee, value, index + 1))
    setDuplicateInList((duplicates && duplicates.length > 0) ? duplicates : [])
  }

  const checkForArrDuplicatesInDB = serials => {
    let nonEmptyArr = serials.filter(s => s !== '')
    // find duplicates in DB
    let duplicates = devices.filter(device => {
      let found = false
      nonEmptyArr.forEach(sm => {
        if (sm === device.serial) found = device
      })
      return found
    })
    setDuplicatesInDB((duplicates && duplicates.length > 0) ? duplicates : [])
  }

  const refreshSerialsList = serials => {
    // first reset serial list (render input issues!)
    setSerial([])
    setTimeout(() => {
      setSerial(serials)
    }, 10)
  }

  const handleChange = ({ name, value }) => {
    let modifiedSerials = _.cloneDeep(serial)
    modifiedSerials[name] = value
    // check for duplicates in list
    checkForArrDuplicates(modifiedSerials)
    // check for duplicates in DB
    checkForArrDuplicatesInDB(modifiedSerials)
    setSerial(modifiedSerials)
  }

  const handleAddMore = e => {
    let newSerials = _.cloneDeep(serial)
    newSerials.push('')
    setSerial(newSerials)
  }

  const handleRemoveOne = i => {
    let newSerial = _.cloneDeep(serial)
    newSerial = newSerial.filter((val, index) => index !== i)
    // check for duplicates in list
    checkForArrDuplicates(newSerial)
    // check for duplicates in DB
    checkForArrDuplicatesInDB(newSerial)
    // set serial
    refreshSerialsList(newSerial)
  }

  // create devices mutation
  const [createDevices, { data: mutationData, loading: mutationLoading, error: mutationError }] = useMutation(CREATE_DEVICES, {
    fetchPolicy: 'network-only',
    onCompleted: mutationData => {
      let nmbOfAdded = mutationData.create_devices.length
      setSerialsMemo(serial)
      setOncWarn(false)
      setOncWarnNmb(0)
      setOncSuccess(false)
      setOncErr(false)
      // show messages
      setTimeout(() => {
        // success
        if (serial.length === nmbOfAdded) {
          console.log('added all')
          setOncSuccess(true)
          setTimeout(() => {
            setOncSuccess(false)
          }, 5000)
          // update device list
          initDevices()
        }
        // warning
        if (nmbOfAdded !== 0 && nmbOfAdded < serial.length) {
          console.log('added some')
          setOncWarn(true)
          setOncWarnNmb(nmbOfAdded)
        }
        // fail
        if (nmbOfAdded === 0) {
          console.log('added none')
          setOncErr(true)
        }
        // failed devices
        if (nmbOfAdded !== serial.length) {
          console.log('duplicates detected on mutation response!')
          getDevices()
        }
        // reset all inputs
        setCheckInput(0)
        refreshSerialsList([''])
        setPurchased('')
        setPo('')
      }, 50);
    },
    onError: mutationError => console.log(mutationError)
  })

  const handleDateInputLayout = e => {
    if (e.target.value && e.target.value !== '') {
      e.target.className = 'not_empty'
    } else {
      e.target.className = ''
    }
  }

  useEffect(() => {
    // first load of existing devices
    initDevices()
  }, [])

  return (
    <Container className='CreateDevices'>
      <Header as='h3' floated='left'>
        <Icon name='computer' />
        <Header.Content>
          Devices
          <Header.Subheader>Create new devices:</Header.Subheader>
        </Header.Content>
      </Header>

      <Form onSubmit={handleSubmit} autoComplete='off'>
        {duplWarn && (
          <Message
            negative
            size='small'
            style={{maginTop: '3rem'}}
            onDismiss={() => setDuplWarn(false)}
          >
            <Message.Header>Devices already added:</Message.Header>
            <List >
              {duplicates && duplicates.map(d => (
                <List.Item key={d.id}>
                  <Icon name='computer' size='big' />
                  <List.Content>
                    <List.Header>Serial: {d.serial}</List.Header>
                    <List.Description>Added on: {moment(d.created_at).format('DD/MMM/YYYY')}</List.Description>
                  </List.Content>
                </List.Item>
              ))}
            </List>
          </Message>
        )}
        {oncWarn && (
          <Message
            color='yellow'
            size='small'
            onDismiss={() => setOncWarn(false)}
          >
            <Message.Header>Added some of the devices from your list!</Message.Header>
            <p>Successfully added {oncWarnNmb} out of {serialsMemo.length} devices!</p>
          </Message>
        )}
        {oncErr && (
          <Message
            negative
            size='small'
            onDismiss={() => setOncErr(false)}
          >
            <Message.Header>Failed to add devices!</Message.Header>
            <p>You have already added all of the devices!</p>
          </Message>
        )}
        <Form.Field>
          <Form.Input
            name='po_number'
            type='text'
            label='PO Number'
            placeholder='Enter PO Number'
            required
            value={po}
            onChange={e => {
              setPo(e.target.value)
              setErrFields(false)
            }}
          />
        </Form.Field>
        <Form.Field>
          <Form.Input
            className='date-input'
            name='purchased_at'
            type='date'
            label='Purchased At'
            placeholder='DD/MM/YYYY'
            required
            value={purchased}
            onChange={e => {
              handleDateInputLayout(e)
              setPurchased(e.target.value)
              setErrFields(false)
            }}
          />
        </Form.Field>
        <Form.Field required>
          <label required>Serial</label>
          {serial && serial.map((s, i) => (
            <InputSerial
              key={i + 1}
              handleChange={handleChange}
              val={s}
              i={i}
              isLast={i === serial.length - 1}
              addMore={handleAddMore}
              removeThis={handleRemoveOne}
              checkInput={checkInput}
              duplicates={duplicateInList}
              duplicatesInDB={duplicatesInDB}
            />
          ))}
        </Form.Field>
        {errFields && (
          <Message
            negative
            size='mini'
          >
            <Message.Header>Empty Input Error!</Message.Header>
            <p>All fields must be filed!</p>
          </Message>
        )}
        <div className='clear'>
          <Button
            type='submit'
            floated='right'
            primary
            content='SUBMIT'
            onClick={handleSubmit}
          />
        </div>
        {oncSuccess && (
          <Message
            positive
            size='small'
          >
            <Message.Header>Success!</Message.Header>
            <p>Successfully added {serialsMemo.length} devices!</p>
          </Message>
        )}
      </Form>
    </Container>
  )
}

export default CreateDevices
